import { io } from 'socket.io-client';
import { ManagerOptions } from 'socket.io-client/build/esm/manager';
import { SocketOptions } from 'socket.io-client/build/esm/socket';
import { useMemo } from 'react';
import progressMagicJwtToken from '../../config/constants';

export enum SpeechToTextMessage {
  START_GOOGLE_CLOUD_STREAM = 'startGoogleCloudStream',
  BINARY_AUDIO_DATA = 'binaryAudioData',
  END_GOOGLE_CLOUD_STREAM = 'endGoogleCloudStream',
  GOOGLE_CLOUD_STREAM_ERROR = 'googleCloudStreamError',
  SENTENCE_TRANSCRIPTION = 'speechData',
  LIVE_SENTENCE = 'liveSentence',
}

/**
 * Hook to create a socket to the speech-to-text namespace.
 * @param socketOptions
 */
const useSpeechToTextSocket = (socketOptions?: Partial<ManagerOptions & SocketOptions>) => {
  if (!process.env.REACT_APP_SPEECH_TO_TEXT_WS_ENDPOINT) {
    throw new Error('REACT_APP_SPEECH_TO_TEXT_WS_ENDPOINT is not defined');
  }

  const url = process.env.REACT_APP_SPEECH_TO_TEXT_WS_ENDPOINT;
  const token = localStorage.getItem(progressMagicJwtToken);

  return useMemo(
    () =>
      io(url, {
        extraHeaders: {
          Authorization: `Bearer ${token}`,
        },
        ...socketOptions,
      }),
    [url, socketOptions, token]
  );
};

export default useSpeechToTextSocket;
